export const getRowConfig = (t, data = {}) => [
  {
    label: t('Active Mines'),
    render: () => <span>{data.activeMines || 0}</span>,
  },
  {
    label: t('Commodity Footprint'),
    render: () => (
      <>
        <span>{data.commodityFootprint?.weight || 0}</span>
        <span className="sm">/{data.commodityFootprint?.per || t('month')}</span>
      </>
    ),
  },
  {
    label: t('Workers Benefiting'),
    render: () => <span>{data.workers || 0}</span>,
  },
  {
    label: t('Investment'),
    render: () => <span>${Number(data.investment || 0).toLocaleString('en-us')}</span>,
  },
]
